import * as React from "react";
import { adminClipUrl } from '../config/backend';

interface Props {
  clipId: number;
  agentResultId: number;
  isDatalakeClip: boolean;
}

export default function ShowClipIdHeader({
  clipId,
  agentResultId,
  isDatalakeClip,
}: Props) {
  const style = {
    margin: "0",
  };
  return (
    <>
      {!isDatalakeClip && (
        <div>
          <p style={style}>
            Clip ID:&nbsp;
            <a
              href={adminClipUrl(clipId)}
              target="_blank" rel="noreferrer"
            >
              {clipId}
            </a>
          </p>
          <p style={style}>Agent Result ID:&nbsp;{agentResultId}</p>
        </div>
      )}
    </>
  );
}
